import { createSelector } from '@reduxjs/toolkit';
import { getItemResellerPackagings } from '../utils/reselectors';

export interface ResellerPackagingAsPromo {
  id: string;
  title: string;
  description: string;
  image: string;
  link: {
    name: string;
    url: string;
  };
}

export const getItemResellerPackagingsAsPromo = createSelector(
  getItemResellerPackagings,
  (resellerPackagings): ResellerPackagingAsPromo[] => {
    if (!resellerPackagings || resellerPackagings.length === 0) {
      return [];
    }

    return resellerPackagings.map((packaging) => ({
      id: packaging.id,
      description: packaging.description,
      image: packaging.imageUrl,
      link: {
        name: packaging.ctaName,
        url: packaging.ctaUrl,
      },
      title: packaging.title,
    }));
  },
);
